export enum ProductDatingUponReceiptIssueTypeInternational {
    SHORT_DATED_PRODUCT = 'Short Dated Product',
    EXPIRED_PRODUCT = 'Expired Product',
    COUNTRY_MINIMUM_DATING_NOT_MET = 'Country Minimum Dating Not Met',
    BACK_LOT = 'Back Lot'
}
